import * as React from 'react';
import FlexAppView from '../views/library/app-flex.view';
import FixedAppView from '../views/library/app-fixed.view';

import { IPackageListingAppText } from '../custom/classes/package-listing-text';

import { IPackageListingAppState } from '../redux-state';
import { connect } from 'react-redux';
import { IPackageListingAppSettings } from '../custom/classes/package-listing-settings';

interface AppExternalProps {
}

interface StateToProps {
    text: IPackageListingAppText;
    settings: IPackageListingAppSettings;
}

export type AppProps = AppExternalProps & StateToProps;

export class AppComponent extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render() {
        return (
            <>
                {this.props.settings.isFixed ?
                    <FixedAppView {...this.props} />
                    :
                    <FlexAppView {...this.props} />
                }
            </>
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: AppExternalProps): StateToProps {
    return {
        text: state.packageListingText,
        settings: state.packageListingSettings
    }
}

export default connect<StateToProps>(mapStateToProps)(AppComponent);
